var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":"","loading":_vm.generandoMinuta},on:{"click":function($event){return _vm.generarMinutaPdf()}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-file-pdf-box")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }